import { Http } from "@angular/http";
import { Injectable } from "@angular/core";
import * as Tx from "ethereumjs-tx";
import * as Web3 from "web3";
/*import {
  AppContract,
  IssuerContract,
  MarketContract,
  WatacoinContract
} from '../app/app.contract';*/
import { ContractsService } from "../app/app.contract.service";
import { AppUtilities } from "../app/app.utilities";
import { Idol, Token, Transaction, Wallet } from "../app/app.models";
import { WalletService } from "./wallet.service";
import { ConfigService } from "../services/config.service";

import * as firebase from "firebase";
import { ReplaySubject } from "rxjs";

@Injectable()
export class NodeService {
  //public web3: Web3 = AppContract.web3;
  public web3: Web3 = this.contractService.web3;
  private server: string;
  private serverBackup: string;

  public constructor(
    private http: Http,
    private utilities: AppUtilities,
    private walletService: WalletService,
    private configService: ConfigService,
    private contractService: ContractsService
  ) {
    //PRODUCTION
    //this.web3 = contractService.web3;
    this.web3.setProvider(
      new this.web3.providers.HttpProvider("https://rsk.marketpay.io")
    );
    if (!this.web3.isConnected()) {
      this.web3.setProvider(
        new this.web3.providers.HttpProvider("https://rsk.marketpay.io")
      );
    }
    //TEST
    /**
    this.web3.setProvider(
      new this.web3.providers.HttpProvider('https://public-node.testnet.rsk.co')
    ); */
  }

  public getIdols(): Promise<any[]> {
    this.web3.eth.defaultAccount = this.walletService.getAddress();
    return new Promise((resolve, reject) => {
      let idols: any[] = [];
      let idolId = 1;

      while (idolId) {
        let idol = this.contractService.IssuerContract.getIssuerById.call(
          idolId
        );

        if (idolId != 1) {
          if (idol[2] == "0x0000000000000000000000000000000000000000") break;
        }
        idolId++;
        // Push idol to idols array
        idols.push({
          idolId: idol[0].toNumber(),
          address: idol[2]
        });
      }

      resolve(idols);
    });
  }

  public getConcretIdols(index): Promise<Idol[]> {
    this.web3.eth.defaultAccount = this.walletService.getAddress();
    return new Promise((resolve, reject) => {
      let idols: Idol[] = [];
      let assetId = 1;
      assetId = index;
      while (assetId) {
        let idol = this.contractService.IssuerContract.getIssuerById.call(
          assetId
        );

        if (assetId != 1) {
          if (idol[2] == "0x0000000000000000000000000000000000000000") break;
        }
        assetId++;
        // Push idol to idols array
        idols.push({
          assetId: idol[0].toNumber(),
          address: idol[2],
          name: idol[1],
          description: "",
          mainImageUrl: "",
          featuredImageUrl: "",
          category: "",
          facebookUrl: "",
          twitterUrl: "",
          instagramUrl: ""
        });
      }

      resolve(idols);
    });
  }

  public getIdolsInitial(): Promise<Idol[]> {
    this.web3.eth.defaultAccount = this.walletService.getAddress();
    return new Promise((resolve, reject) => {
      let idols: Idol[] = [];
      let assetId = 1;

      while (assetId) {
        let idol = this.contractService.IssuerContract.getIssuerById.call(
          assetId
        );

        // Cancel while on empty token
        if (idol[3].trim() === "") break;

        // Increase assetId
        assetId++;

        // https://regex101.com/r/kmfXxX/1
        let regex = /(.+); description='(.+)'; mainImageUrl='(.+)'; featuredImageUrl='(.+)'; category='(.+)'; facebookUrl='(.+)'; twitterUrl='(.+)'; instagramUrl='(.+)'/.exec(
          idol[3].trim()
        );

        // Formating error, skip idol
        if (regex === null) continue;
        // Push idol to idols array
        idols.push({
          assetId: idol[0].toNumber(),
          address: idol[2],
          name: regex[1].replace('"', ""),
          description: regex[2],
          mainImageUrl: regex[3],
          featuredImageUrl: regex[4],
          category: regex[5],
          facebookUrl: regex[6],
          twitterUrl: regex[7],
          instagramUrl: regex[8]
        });
      }

      resolve(idols);
    });
  }

  public getAssetIdsForSale() {
    this.web3.eth.defaultAccount = this.walletService.getAddress();
    return new Promise((resolve, reject) => {
      this.contractService.MarketContract.getAssetsIdsForSale.call(
        (error, result) => {
          if (error) reject(error);
          let ids = result.filter(id => id > 0);
          if (ids) ids.reverse();
          resolve(ids);
        }
      );
    });
  }

  public getAssetsIdsOwnedBy(address: string) {
    this.web3.eth.defaultAccount = this.walletService.getAddress();
    return new Promise((resolve, reject) => {
      this.contractService.AppContract.getAssetsIdsOwnedBy.call(
        address,
        (error, result) => {
          if (error) reject(error);
          let ids = result.filter(id => id > 0);
          if (ids) ids.reverse();
          resolve(ids);
        }
      );
    });
  }

  public getAssetsIdsIssuedBy(address: string) {
    this.web3.eth.defaultAccount = this.walletService.getAddress();
    return new Promise((resolve, reject) => {
      this.contractService.AppContract.getAssetsIdsIssuedBy.call(
        address,
        (error, result) => {
          if (error) reject(error);
          let ids = result.filter(id => id > 0);
          console.log("ids idols generados " + ids);
          if (ids) ids.reverse();
          resolve(ids);
        }
      );
    });
  }

  public getAssets(idsAsset: any[]): Promise<Token[]> {
    this.web3.eth.defaultAccount = this.walletService.getAddress();
    return new Promise((resolve, reject) => {
      let tokens: Token[] = [];
      console.log(
        "Node Service getAssets " + JSON.stringify(tokens) + "ids Assets ",
        idsAsset
      );
      for (let asset of idsAsset) {
        let token2 = this.contractService.AppContract.getAssetById2.call(
          parseInt(asset)
        );
        let token = this.contractService.AppContract.getAssetById.call(
          parseInt(asset)
        );
        //   console.log('token ' + JSON.stringify(token));
        //  console.log('token ' + JSON.stringify(token2));
        // console.log('token[3] ', token[3], 'token[3].trim()', token[3].trim());

        let description = token[3].split("description='");
        if (description.length > 1) {
          description.shift();
          description = description.join("description='").split("'; length='");
          description.pop();
          description = description.join("'; length='");
        }
        token[3] = token[3].split("\n").join(" ");

        // Cancel while on empty token
        if (token[3].trim() === "") break;

        let regex = /(.+); urlImage='(.+)'; hashSHA1ImageVerification='(\b[0-9a-f]{5,40}\b)'; subtitle='(.+)'; description='(.+)'; length='(\d+)'; date='(\d{4}\-\d{1}\-\d{1})'; verified='(true|false)'/.exec(
          token[3].trim()
        );

        if (regex == null) {
          regex = /(.+); urlImage='(.+)'; hashSHA1ImageVerification='(\b[0-9a-f]{5,40}\b)'; subtitle='(.+)'; description='(.+)'; length='(\d+)'; date='(\d{4}\-\d{2}\-\d{2})'; verified='(true|false)'/.exec(
            token[3].trim()
          );
        }
        if (regex == null) {
          regex = /(.+); urlImage='(.+)'; hashSHA1ImageVerification='(\b[0-9a-f]{5,40}\b)'; subtitle='(.+)'; description='(.+)'; length='(\d+)'; date='(\d{4}\-\d{1}\-\d{2})'; verified='(true|false)'/.exec(
            token[3].trim()
          );
        }
        if (regex == null) {
          regex = /(.+); urlImage='(.+)'; hashSHA1ImageVerification='(\b[0-9a-f]{5,40}\b)'; subtitle='(.+)'; description='(.+)'; length='(\d+)'; date='(\d{4}\-\d{2}\-\d{1})'; verified='(true|false)'/.exec(
            token[3].trim()
          );
        }

        // Formating error, skip token
        console.log("regex ", regex);
        if (regex === null) continue;
        // Push token to tokens array
        tokens.push({
          assetId: token[0].toNumber(),
          owner: token[1],
          issuer: token[2],
          title: regex[1].replace("Cromo de ", "").replace('"', ""),
          image: regex[2],
          sha1: regex[3],
          last_price: token[4].toNumber() / 1000000,
          next_price: token2[6].toNumber() / 1000000,
          status: token[5].toNumber(),
          subtitle: regex[4],
          description: description,
          length: parseInt(regex[6], 10),
          date: new Date(regex[7]),
          verified: regex[8] === "true",
          mint: regex[9] ? regex[9] : "Watafan"
        });

        // console.log('Tokens ' + JSON.stringify(tokens));
      }
      resolve(tokens);
    });
  }

  public getWallet(): Promise<Wallet> {
    this.web3.eth.defaultAccount = this.walletService.getAddress();
    return new Promise((resolve, reject) => {
      const address = this.walletService.getAddress();
      let ethers = 0;
      this.web3.eth.getBalance(address, (error, result) => {
        if (error) reject(error);
        if (result) {
          ethers = this.web3.fromWei(result, "ether").toNumber();
          console.log("GetWallet ethers " + ethers);
        }

        resolve({
          address: address,
          ethers: ethers,
          mnemonic: this.walletService.getMnemonic()
        });
      });
    });
  }

  public getBalanceWatacoins(): Promise<Wallet> {
    this.web3.eth.defaultAccount = this.walletService.getAddress();
    return new Promise((resolve, reject) => {
      const address = this.walletService.getAddress();
      let watacoins = 0;
      this.contractService.WatacoinContract.balanceOf.call(
        address,
        (error, result) => {
          if (error) reject(error);
          if (result) {
            watacoins = result.toNumber() / 1000000;
          }
          resolve({
            address: address,
            watacoins: watacoins,
            mnemonic: this.walletService.getMnemonic()
          });
        }
      );
    });
  }

  public sendTokens(from: string, to: string, amount: number) {
    var rawTx = {
      from: from,
      to: to,
      value: amount,
      gasPrice: this.configService.getGasPrice(),
      gasLimit: this.configService.getGasLimit(),
      nonce: this.web3.eth.getTransactionCount(this.walletService.getAddress())
    };
    return new Promise((resolve, reject) => {
      var tx = new Tx(rawTx);
      tx.sign(this.walletService.getPrivateKey());

      var serializedTx = tx.serialize();
      this.web3.eth.sendRawTransaction(
        "0x" + serializedTx.toString("hex"),
        function(err, hash) {
          if (!err) resolve(hash);
          reject(err);
        }
      );
    });
  }

  public sendWatacoins(from: string, to: string, amount: number) {
    let options = this.contractService.WatacoinContract.transfer.toPayload([
      to,
      amount
    ]);
    let transaction: Transaction = {
      from: from,
      to: this.contractService.WatacoinContract.address,
      data: options.data
    };

    return this.sendTransaction(transaction, true);
  }
  //PRODUCTION

  public sendTransaction(data: Transaction, signed: Boolean = false) {
    this.utilities.loading(
      "Cargando Gas para poder realizar la transacción. Este proceso puede tardar algunos minutos…"
    );
    return new Promise((resolve, reject) => {
      let options = Object.assign(
        {
          gasPrice: this.configService.getGasPrice(),
          gasLimit: this.configService.getGasLimit(),
          value: data.value ? data.value : 0,
          nonce: this.web3.eth.getTransactionCount(data.from)
        },
        data
      );

      let transaction = new Tx(options);

      if (signed) transaction.sign(this.walletService.getPrivateKey());

      if (typeof transaction === "object")
        transaction = transaction.serialize().toString("hex");
      if (!transaction.startsWith("0x")) transaction = "0x" + transaction;

      var address = this.walletService.getAddress();

      return this.http
        .get(
          `https://faucet.watafan.com:1315/mainnetrsk/${address}/a/b?waitmined=1`
        )
        .subscribe((response: any) => {
          console.log("devolviendo la respuesta ", response._body);
          var res = JSON.parse(response._body);
          console.log("error " + res.error);
          this.utilities.loadingDismiss();
          if (res.error == 0) {
            this.web3.eth.sendRawTransaction(transaction, (error, tx) => {
              console.log("Envío la tx despues de cargar wallet " + tx);
              if (!error) return resolve(tx);
              return reject(error);
            });
          }
          if (res.error !== 0) {
            return this.getWallet().then(wallet => {
              if (wallet.ethers >= this.configService.getMinGas()) {
                console.log("enviar transacción. " + wallet.ethers);
                this.web3.eth.sendRawTransaction(transaction, (error, tx) => {
                  console.log("Envío la tx despues de cargar wallet " + tx);
                  if (!error) return resolve(tx);
                  return reject(error);
                });
              } else {
                console.log("eatamos recargando tu wallet");
                var idioma = this.configService.getIdiom();
                if (idioma == "en")
                  this.utilities.alert(
                    "The operation has not been performed. We are recharging the Gas from your wallet. In a few minutes you can perform the action."
                  );
                if (idioma == "es")
                  this.utilities.alert(
                    "La operación no se ha realizado. Estamos recargando el Gas de su wallet. En unos minutos podrá realizar la acción."
                  );
              }
            });
          }
        });
    });
  }

  //TESTNET
  /*
  public sendTransaction(data: Transaction, signed: Boolean = false) {
    this.utilities.loading(
      'Cargando Gas para poder realizar la transacción. Este proceso puede tardar algunos minutos…'
    );
    return new Promise((resolve, reject) => {
      let options = Object.assign(
        {
          gasPrice: this.configService.getGasPrice(),
          gasLimit: this.configService.getGasLimit(),
          value: data.value ? data.value : 0,
          nonce: this.web3.eth.getTransactionCount(data.from)
        },
        data
      );

      let transaction = new Tx(options);

      if (signed) transaction.sign(this.walletService.getPrivateKey());

      if (typeof transaction === 'object')
        transaction = transaction.serialize().toString('hex');
      if (!transaction.startsWith('0x')) transaction = '0x' + transaction;

      var address = this.walletService.getAddress();

      this.utilities.loadingDismiss();

      this.web3.eth.sendRawTransaction(transaction, (error, tx) => {
        console.log('Envío la tx despues de cargar wallet ' + tx);
        if (!error) return resolve(tx);
        return reject(error);
      });
    });
  }
*/
  public getTransaction(hash) {
    this.web3.eth.defaultAccount = this.walletService.getAddress();
    let getTransaction = new Promise((resolve, reject) =>
      setTimeout(() => {
        this.web3.eth.getTransaction(hash, (error, result) => {
          if (!error) return resolve(result);
          this.utilities.loadingDismiss();
          return reject(error);
        });
      }, 5000)
    );

    return getTransaction.then(async (result: any) => {
      if (result.blockNumber) {
        this.utilities.loadingDismiss();
      } else {
        await this.getTransaction(hash);
      }
    });
  }

  public getTransactionTemp(hash) {
    this.web3.eth.defaultAccount = this.walletService.getAddress();
    return new Promise((resolve, reject) =>
      this.web3.eth.getTransaction(hash, (error, result) => {
        if (!error) {
          return resolve(result);
        } else {
          return reject(error);
        }
      })
    );
  }

  public sendTransactionVAlidate(data: Transaction, signed: Boolean = false) {
    this.utilities.loading(
      "Cargando Gas para poder realizar la transacción. Este proceso puede tardar algunos minutos…"
    );
    return new Promise((resolve, reject) => {
      let options = Object.assign(
        {
          gasPrice: this.configService.getGasPrice(),
          gasLimit: this.configService.getGasLimit(),
          value: data.value ? data.value : 0,
          nonce: this.web3.eth.getTransactionCount(data.from)
        },
        data
      );

      let transaction = new Tx(options);

      if (signed) transaction.sign(this.walletService.getPrivateKey());

      if (typeof transaction === "object")
        transaction = transaction.serialize().toString("hex");
      if (!transaction.startsWith("0x")) transaction = "0x" + transaction;

      this.validateWalletSBTC()
        .then((response: any) => {
          this.utilities.loadingDismiss();
          if (response == 0 || response == true) {
            console.log("Response validateWalletSBTC " + response);
            debugger;
            this.web3.eth.sendRawTransaction(transaction, (error, tx) => {
              console.log("Envío la tx despues de cargar wallet " + tx);
              if (!error) return resolve(tx);
              return reject(error);
            });
          } else {
            console.log("Response " + response);
            return resolve("error");
          }
        })
        .catch(() => {
          this.utilities.loadingDismiss();
        });
    });
  }

  private validateWalletSBTC() {
    debugger;
    var address = this.walletService.getAddress();
    return new Promise((resolve, reject) => {
      this.getWallet().then(wallet => {
        if (wallet == null) {
          reject(false);
        }

        if (wallet.ethers < this.configService.getMinGas()) {
          console.log("Faucet ok " + wallet.ethers);
          debugger;
          return this.http
            .get(
              `http://faucet.watafan.com:1314/mainnetrsk/${address}/a/b?waitmined=1`
            )
            .subscribe((response: any) => {
              console.log("devolviendo la respuesta " + response._body);
              var res = JSON.parse(response._body);
              resolve(res.error);
            });
        } else {
          console.log("No faucet " + wallet.ethers);
          resolve(true);
        }
      });
    });
  }

  getEstimateGasPrice() {
    var mingasPrice = this.web3.eth.getBlock("latest").minimumGasPrice;
    if (mingasPrice <= 1) {
      return 1;
    } else {
      return mingasPrice * 1.0001;
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/node.service.ts